function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/TeamFilterRow/index.js";
var _excluded = ["dataAttr"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { SpotType } from "@mlb/react-patterns/dist/components/Spot/spot.types";
import SpotTag from "@mlb/react-patterns/dist/components/SpotTag/spotTag";
import React from "react";
import { TeamFilterRowContainer } from "./styles";
var ComponentKey = "team-filter-row";
var TeamFilterRow = function TeamFilterRow(_ref) {
  var alt = _ref.alt,
    buttonProps = _ref.buttonProps,
    className = _ref.className,
    handlers = _ref.handlers,
    id = _ref.id,
    isFavorite = _ref.isFavorite,
    _ref$lazyload = _ref.lazyload,
    lazyload = _ref$lazyload === void 0 ? false : _ref$lazyload,
    name = _ref.name,
    spotTagProps = _ref.spotTagProps,
    superName = _ref.superName;
  if (!id) {
    console.error("❌ [TeamFilterRow] prop `id` is required"); // eslint-disable-line
    return null;
  }
  var _ref2 = buttonProps || {},
    _ref2$dataAttr = _ref2.dataAttr,
    dataAttr = _ref2$dataAttr === void 0 ? {} : _ref2$dataAttr,
    restButtonProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(TeamFilterRowContainer, _extends({
    className: className,
    dataAttr: _objectSpread({
      "data-testid": "".concat(ComponentKey, "--").concat(id)
    }, dataAttr),
    handlers: handlers
  }, restButtonProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(SpotTag, _extends({
    alt: alt,
    id: id,
    isFavorite: isFavorite,
    lazyload: lazyload,
    name: name,
    superName: superName === "Athletics" ? "" : superName,
    type: SpotType.TEAM,
    width: 40
  }, spotTagProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  })));
};
export default /*#__PURE__*/React.memo(TeamFilterRow);